import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import  {  RecaptchaModule ,  RecaptchaFormsModule  }  from  'ng-recaptcha' ;
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';

import {FlashMessagesModule, FlashMessagesService} from 'angular2-flash-messages';
import {NgxPaginationModule} from 'ngx-pagination';
import { OrderModule } from 'ngx-order-pipe';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxNavigationWithDataComponent} from 'ngx-navigation-with-data';

//firebase
import { AngularFireModule } from '@angular/fire'; // Firebase config
import { AngularFirestoreModule } from '@angular/fire/firestore'; // For Cloud Firestore
import { AngularFireStorageModule, BUCKET} from '@angular/fire/storage'; // For Cloud Firestore
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from 'src/environments/environment'; // Config

import { AppComponent } from './app.component';
import { AuthGuard } from './guards/auth.guard';
import { SUGuard } from './guards/su.guard';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { TrackingService } from './services/tracking.service';
import { TrackingComponent } from './components/tracking/tracking.component';
import { TrackingEditComponent } from './components/tracking-edit/tracking-edit.component';
import { TrackingManagerComponent } from './components/tracking-manager/tracking-manager.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {path: '', component:DashboardComponent},
      {path: 'tracking', component:TrackingComponent},
      {path: 'tracking/manager',
      canActivate: [SUGuard],
      children:[
        {path:'', component:TrackingManagerComponent}
      ]
    
      },
      {path: 'tracking/edit', component:TrackingEditComponent},
    ]
  },
  {path: '**', component: ErrorPageComponent},
  {path: 'error', component: ErrorPageComponent}
];

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
    NavBarComponent,
    DashboardComponent,
    TrackingComponent,
    TrackingEditComponent,
    TrackingManagerComponent
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebaseConfig), // Import firebase
    RouterModule.forRoot(routes, { useHash: true }),
    RecaptchaModule,
    RecaptchaFormsModule,
    NgxPaginationModule,
    OrderModule,
    FilterPipeModule,
    FlashMessagesModule,
    AngularFirestoreModule, // Import firestore
    AngularFireStorageModule, // Import fireStorage
    AngularFireAuthModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule
  ],
  providers: [
    FlashMessagesService,
    {provide:BUCKET, useValue:"gs://manage-transportation.appspot.com"},
    AuthGuard,
    SUGuard,
    TrackingService,
    NgxNavigationWithDataComponent
],
  bootstrap: [AppComponent]
})


export class AppModule { }
